module.exports = __webpack_public_path__ + "static/img/icon-4.f5bf7e2b.png";